"use client";

import { motion } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react";

interface ContactCardProps {
  type: "phone" | "email" | "address";
  title: string;
  content: string | string[];
}

export default function ContactCard({
  type,
  title,
  content,
}: ContactCardProps) {
  const icons = { phone: Phone, email: Mail, address: MapPin };
  const Icon = icons[type];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      whileHover={{ y: -4 }}
      className="flex items-start gap-3 sm:gap-4 rounded-xl border border-border bg-white p-5 sm:p-6 shadow-sm transition-shadow hover:shadow-md"
    >
      <div className="flex h-12 w-12 sm:h-14 sm:w-14 shrink-0 items-center justify-center rounded-full bg-[var(--brand-yellow)]">
        <Icon className="h-5 w-5 sm:h-6 sm:w-6 text-black" />
      </div>
      <div className="flex flex-col gap-1">
        <h3 className="text-xs sm:text-sm font-semibold uppercase tracking-wide text-black">
          {title}
        </h3>
        {Array.isArray(content) ? (
          <div className="text-[13px] sm:text-sm text-muted-foreground">
            {content.map((line, i) => (
              <p key={i}>{line}</p>
            ))}
          </div>
        ) : (
          <p className="text-[13px] sm:text-sm text-muted-foreground">
            {content}
          </p>
        )}
      </div>
    </motion.div>
  );
}
